import { Col, Row, Typography } from 'antd';
import clsx from 'clsx';
import React, { useState } from 'react';
// import logo_mind from "../../IMG/54591670-ac0a0180-4a65-11e9-846c-e55ffce0fe7b.png";
import logo_mind from '../../../IMG/logo_Mind.svg';
import logo_savina from '../../../IMG/savina_logo.png';
import FormLogin from '../Component/FormLogin/FormLogin';
import Register from '../Component/Register/Register';
import style from './Login.module.scss';
export default function LoginPage() {
  const { Title } = Typography;
  const [itemSelect, setItemSelect] = useState<Boolean>(false);

  return (
    <Row align={'middle'} justify={'center'} className={style.root}>
      <Row align={'middle'} className={style.content}>
        <Col md={24} lg={14} xl={12} className={style.form_content}>
          <Row align={'middle'} justify={'space-between'} className={style.header_content}>
            <img src={logo_mind} alt="logo_mind" height="50px" width="auto" />
            <img src={logo_savina} alt="logo_savina" height="50px" width="auto" />
          </Row>
          <Row align={'middle'} justify={'center'} style={{ height: 'calc(100% - 120px)' }}>
            <Title level={2} className={style.title_content}>
              SolarFarm
            </Title>
            <Row className={style.tabs_content}>
              <Row style={{ width: '100%', height: '40px' }}>
                <Col
                  span={12}
                  className={clsx(style.item_header_tabs, {
                    [style.active]: !itemSelect,
                  })}
                  onClick={() => setItemSelect(false)}
                >
                  Login
                </Col>
                <Col
                  span={12}
                  className={clsx(style.item_header_tabs, {
                    [style.active]: itemSelect,
                  })}
                  onClick={() => setItemSelect(true)}
                >
                  Request a demo
                </Col>
              </Row>
              <Row
                align={'middle'}
                justify={'center'}
                style={{ width: '100%', height: 'calc(100% - 40px)' }}
              >
                {!itemSelect ? <FormLogin /> : <Register setItemSelect={setItemSelect} />}
              </Row>
            </Row>
          </Row>
          <Row className={style.footer_content}>
            <div>Copyright &copy; 2021 Mindlot All rights reserved</div>
            <div>Terms & conditions</div>
          </Row>
        </Col>
        <Col md={0} lg={10} xl={12} className={style.image_content}></Col>
      </Row>
    </Row>
  );
}
